module.exports = {"UserPoolId":"eu-central-1_opGGTLW96","AppClientId":"nn745407crdqlq7a8q4kv72oq","ApiGateway":"https://e4qem7w512.execute-api.eu-central-1.amazonaws.com/prod","ServerlessDeploymentBucketName":"blackbox-frontend-prod-serverlessdeploymentbucket-3rttn80vbuxk"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 1701
// module chunks = 0